import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import get from 'get-value';
import {SubmissionError} from 'redux-form';
import * as moment from 'moment';
import ExportCommercialForm from './ExportCommercialForm';
import Loader from '../../Loader';
import PageHeader from '../../common/PageHeader';
import checkRoles from '../../common/roleChecker/RoleChecker';
import exportMessages from '../../../intl/modules/exportMessages';
import {fetchCommercialDealers} from '../../../actions/commercial/actionCommercialDealers';
import {
    createCommercialExport,
    downloadCommercialExport,
    fetchCommercialExport
} from '../../../actions/commercial/actionCommercialExport';
import {
    FIELD_PFX,
    FIELD_SFX,
    FIELD_EXPORT_TYPE,
    FIELD_EXPORT_CHARSET
} from '../../../constants/formConstants';
import {XLS} from '../../../constants/exportConstant';
import {fetchSubjects} from '../../../actions/admin/actionAdminSubjectSettings';

class ExportCommercialPage extends Component {
    componentDidMount() {
        this.props.fetchCommercialDealers();
        this.props.fetchCommercialExport();
    }

    handleSubmit = (values) => {
        const pfx = get(values, 'pfxNumber', '').length;
        const sfx = get(values, 'sfxNumber', '').length;

        if (pfx > 0 && sfx === 0) {
            throw new SubmissionError({
                [FIELD_SFX]: 'Fill complete ticket number'
            })
        }

        if (pfx === 0 && sfx > 0) {
            throw new SubmissionError({
                [FIELD_PFX]: 'Fill complete ticket number'
            })
        }

        const temp = JSON.parse(JSON.stringify((({assigned, dealer = {}, status, priority}) => {
            const {dealerNumber, dealerName} = dealer;
            return ({
                lastEditor: assigned ? assigned.trim() : undefined,
                dealerNumber: dealerNumber ? dealerNumber.trim() : undefined,
                dealerName: dealerName ? dealerName.trim() : undefined,
                status,
                priority
            });
        })(values)));

        if (pfx || sfx) {
            temp.ticketNumber = `${values.pfxNumber}-${values.sfxNumber}`;
        }

        const exportFilter = {};
        exportFilter.filter = [];
        for (let key in temp) {
            if (temp.hasOwnProperty(key)) {
                if (key === 'lastEditor') {
                    temp[key].split(' ').forEach(element => exportFilter.filter.push({id: key, value: element}));
                } else {
                    exportFilter.filter.push({id: key, value: temp[key]})
                }
            }
        }
        if (values.from) {
            exportFilter.from = moment(values.from).add(12, 'hours').toISOString().substr(0, 10);
        }
        if (values.to) {
            exportFilter.to = moment(values.to).add(12, 'hours').toISOString().substr(0, 10);
        }
        if (values.customDeadline) {
            exportFilter.customDeadline = Number(values.customDeadline);
        }
        exportFilter.type = values.type;
        if (!exportFilter.type) {
            exportFilter.type = XLS;
        }
        exportFilter.charset = values.charset;
        this.props.createCommercialExport(exportFilter);
    };

    downloadExport = () => {
        this.props.downloadCommercialExport(this.props.exportRecord);
    };

    render() {
        const {isLoadingDealer, isLoadingExport, charSets} = this.props;
        if (isLoadingDealer || isLoadingExport
        ) {
            return <Loader/>;
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...exportMessages.TITLE}/>}/>
                <ExportCommercialForm onSubmit={this.handleSubmit}
                                      form={'commercialExportForm'}
                                      downloadExport={this.downloadExport}
                                      initialValues={{
                                          [FIELD_EXPORT_TYPE]: XLS,
                                          [FIELD_EXPORT_CHARSET]: charSets[0]
                                      }}/>
            </div>
        )
    }
}

ExportCommercialPage.propTypes = {
    fetchCommercialDealers: PropTypes.func.isRequired,
    fetchCommercialExport: PropTypes.func.isRequired,
    createCommercialExport: PropTypes.func.isRequired,
    downloadCommercialExport: PropTypes.func.isRequired,
    exportRecord: PropTypes.object.isRequired,
    isLoadingDealer: PropTypes.bool.isRequired,
    isLoadingExport: PropTypes.bool.isRequired,
    charSets: PropTypes.array.isRequired,
};

const mapStateToProp = state => ({
    exportRecord: state.commercialExportTickets.exportRecord,
    isLoadingDealer: state.commercialDealer.isLoadingDealer,
    isLoadingExport: state.commercialExportTickets.isLoadingExport,
    charSets: state.profile.userDetail.charSets,
    isLoadingSubjects: state.adminSubjectSettings.isLoading,
    subjects: state.adminSubjectSettings.subjectSettings.subjects,
});

export default checkRoles(connect(mapStateToProp, {
    fetchCommercialDealers,
    fetchCommercialExport,
    createCommercialExport,
    downloadCommercialExport,
    fetchSubjects,
})(injectIntl(ExportCommercialPage)), ['CC_EDITOR'])
